import Vue from "vue";
import VueI18n from "vue-i18n";
// import Cookies from 'js-cookie'
import elementEnLocale from "element-ui/lib/locale/lang/en"; // element-ui lang
import elementZhLocale from "element-ui/lib/locale/lang/zh-CN"; // element-ui lang

import enLocale from "./en/index";
import zhLocale from "./zh/index";

// import enUSLocale from "vue-cron-generator/src/locale/en-US";
// import zhCNLocale from "vue-cron-generator/src/locale/zh-CN";

Vue.use(VueI18n);
const messages = {
  en: {
    ...enLocale,
    ...elementEnLocale
    // ...enUSLocale
  },
  zh: {
    ...zhLocale,
    ...elementZhLocale
    // ...zhCNLocale
  }
};

// export function getLanguage() {
//   // const chooseLanguage = Cookies.get('language')
//   // if (chooseLanguage) return chooseLanguage

//   // if has not chooseLanguage
//   // const language = (navigator.language || navigator.browserLanguage).toLowerCase()
//   // const locales = Object.keys(messages)
//   // for (const locale of locales) {
//   //     if (language.indexOf(locale) > -1) {
//   //         return locale
//   //     }
//   // }
//   return "en";
 
// }

const i18n = new VueI18n({
  // locale: getLanguage(),
  locale: "en",
  messages
});

export default i18n;






// WEBPACK FOOTER //
// ./src/lang/index.js